<template>
  <Card class="col12-of-12--medium-up">
    <CardHeading
      :heading="getText('title')"
      :showCapacity="false"
      :buttonText="getText('addButton')"
      @button-click="addItem"
    />
    <div>
      <draggable
        v-model="items"
        @end="reorder($event)"
        v-bind="dragOptions"
        handle=".handle-wrapper"
      >
        <transition-group>
          <DraggableInputContentItem
            v-for="item in items"
            :key="item.id || item.uniqueId"
            :data="item"
            :value="item.name"
            :placeholder="getText('inputPlaceholder')"
            @update-input="updateInput"
            @delete-click="askConfirmation(item)"
          />
        </transition-group>
      </draggable>
      <Modal
        v-if="showModal"
        okText="Delete"
        cancelText="Close"
        :header="getText('modalTitle')"
        :body="getText('modalBody')"
        @cancel="showModal = false"
        @confirm="deleteItem"
      />
    </div>
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card';
import CardHeading from '@/components/DesignSystem/CardHeading';
import draggable from 'vuedraggable';
import DraggableInputContentItem from '@/components/DesignSystem/DraggableInput/DraggableInputContentItem';
import Modal from '@/components/Modal';

export default {
  components: {
    Modal,
    DraggableInputContentItem,
    Card,
    CardHeading,
    draggable,
  },
  props: {
    namespace: String,
    name: String,
  },
  data() {
    return {
      showModal: false,
      deletePayload: '',
    };
  },
  beforeUpdate() {
    if (this.items.length === 0) {
      this.addItem();
    }
  },
  computed: {
    items: {
      get() {
        return this.$store.getters[`${this.namespace}/items`].filter(
          i => !i.delete
        );
      },
      set(payload) {
        this.$store.commit(`${this.namespace}/setItems`, payload);
      },
    },
    dragOptions() {
      return {
        animation: 200,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    getText(id) {
      const nameLowerCase = this.name.toLowerCase();
      switch (id) {
        case 'addButton':
          return `Add ${nameLowerCase}`;
        case 'inputPlaceholder':
          return `Add a ${nameLowerCase} to organize your content`;
        case 'modalTitle':
          return `Delete ${nameLowerCase}`;
        case 'modalBody':
          return `This action cannot be undone and will impact all partners connected to this ${nameLowerCase}, are you sure you want to delete this?`;
        case 'title':
        default:
          return this.name;
      }
    },
    askConfirmation(payload) {
      this.showModal = true;
      this.deletePayload = payload;
    },
    addItem() {
      const payload = {
        order: this.items.length,
        uniqueId: Math.floor(Math.random() * 10000), // For draggable behavior
        new: true,
      };
      this.$store.dispatch(`${this.namespace}/addItem`, payload);
    },
    deleteItem() {
      this.$store.dispatch(`${this.namespace}/deleteItem`, this.deletePayload);
      this.showModal = false;
    },
    updateInput(payload) {
      this.$store.dispatch(`${this.namespace}/editItem`, payload);
    },
    reorder(event) {
      this.items = this.items.map((item, i) => ({
        ...item,
        order: i,
      }));
      this.findItemsToUpdate(event);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`);
    },

    findItemsToUpdate(event) {
      const start = event.oldIndex;
      const end = event.newIndex;

      if (start < end) {
        for (let i = start; i <= end; i++) {
          if (this.items[i]['id']) {
            this.$set(this.items[i], 'update', true);
          }
        }
      } else {
        for (let i = end; i <= start; i++) {
          if (this.items[i]['id']) {
            this.$set(this.items[i], 'update', true);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ghost {
  opacity: 0;
}
</style>
